<script lang="ts">
    export let color:IconColors = 'text';
    export let icon:IconTypes;
    export let disabled:boolean = false;

    let strokeClass = 'stroke-text';
    let fillClass = 'fill-text';

    $: if (color === 'alert') {
        strokeClass = 'stroke-alert';
        fillClass = 'fill-alert';
    } else if (color === 'black') {
        strokeClass = 'stroke-black';
        fillClass = 'fill-black';
    } else if (color === 'white') {
        strokeClass = 'stroke-white';
        fillClass = 'fill-white';
    } else if (color === 'disabled' || disabled) {
        strokeClass = 'stroke-disabled';
        fillClass = 'fill-disabled';
    }

</script>

<script context="module" lang="ts">
    export type IconTypes = 'none' | 'settings' | 'carret up' | 'carret down' | 'di' | 'alert' | 'anchor' | 'x' | 'sun' | 'swatches' | 'code' | 'plus' | 'menu' | 'human' | 'info' | 'rainbow' | 'copy';
    export type IconColors = 'text' | 'disabled' | 'alert' | 'white' | 'black';
</script>

{#if icon === 'settings' }
    <!-- <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle class="{fillClass}" cx="6" cy="5" r="2" fill=#000000/>
        <circle class="{fillClass}" cx="9" cy="11" r="2" fill=#000000/>
        <rect class="{fillClass}" x="2" y="4" width="12" height="2" rx="1" fill=#000000/>
        <rect class="{fillClass}" x="2" y="10" width="12" height="2" rx="1" fill=#000000/>
    </svg> -->
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle class="{fillClass}" cx="5.5" cy="5.5" r="1.5" fill="black"/>
        <circle class="{fillClass}" cx="9.5" cy="10.5" r="1.5" fill="black"/>
        <rect class="{fillClass}" x="2" y="5" width="12" height="1" rx="0.5" fill="black"/>
        <rect class="{fillClass}" x="2" y="10" width="12" height="1" rx="0.5" fill="black"/>
    </svg> 
{/if}

{#if icon === 'carret up' }
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path class="{strokeClass}" d="M2.5 10.5L8 5L13.5 10.5" stroke=#000000 stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
{/if}

{#if icon === 'carret down' }
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path class="{strokeClass}" d="M2.5 5L8 10.5L13.5 5" stroke=#000000 stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
{/if}

{#if icon === 'di' }
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path class="{fillClass}" fill-rule="evenodd" clip-rule="evenodd" d="M7.49998 0.288699C7.80938 0.110066 8.19058 0.110066 8.49998 0.288699L14.4282 3.71135C14.7376 3.88998 14.9282 4.22011 14.9282 4.57737L14.9282 11.4227C14.9282 11.7799 14.7376 12.1101 14.4282 12.2887L8.49998 15.7113C8.19058 15.89 7.80938 15.89 7.49998 15.7113L1.57178 12.2887C1.26238 12.1101 1.07178 11.7799 1.07178 11.4227L1.07178 4.57737C1.07178 4.22011 1.26238 3.88998 1.57178 3.71135L7.49998 0.288699ZM8.99998 3.75002C8.99998 4.16424 8.55227 4.50002 7.99998 4.50002C7.4477 4.50002 6.99998 4.16424 6.99998 3.75002C6.99998 3.33581 7.4477 3.00002 7.99998 3.00002C8.55227 3.00002 8.99998 3.33581 8.99998 3.75002ZM3.69423 10.486C3.97037 10.9643 4.48503 11.1841 4.84375 10.977C5.20247 10.7699 5.26941 10.2143 4.99327 9.73598C4.71712 9.25769 4.20247 9.03785 3.84375 9.24496C3.48503 9.45206 3.41809 10.0077 3.69423 10.486ZM3.34375 8.37893C2.98503 8.58603 2.47037 8.36619 2.19423 7.8879C1.91809 7.40961 1.98503 6.85398 2.34375 6.64687C2.70247 6.43977 3.21712 6.65961 3.49327 7.1379C3.76941 7.61619 3.70247 8.17182 3.34375 8.37893ZM5.19423 13.0841C5.47037 13.5624 5.98503 13.7822 6.34375 13.5751C6.70247 13.368 6.76941 12.8124 6.49327 12.3341C6.21712 11.8558 5.70247 11.6359 5.34375 11.843C4.98503 12.0501 4.91809 12.6058 5.19423 13.0841ZM12.2916 9.32314C11.9329 9.11603 11.866 8.56041 12.1421 8.08211C12.4182 7.60382 12.9329 7.38398 13.2916 7.59109C13.6503 7.79819 13.7173 8.35382 13.4411 8.83211C13.165 9.31041 12.6503 9.53025 12.2916 9.32314ZM10.1421 11.5462C9.86596 12.0245 9.9329 12.5801 10.2916 12.7872C10.6503 12.9943 11.165 12.7745 11.4411 12.2962C11.7173 11.8179 11.6503 11.2622 11.2916 11.0551C10.9329 10.848 10.4182 11.0679 10.1421 11.5462Z" fill=#000000/>
    </svg>
{/if}

{#if icon === 'alert' }
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path class="{fillClass}" fill-rule="evenodd" clip-rule="evenodd" d="M8.86604 2.5C8.48114 1.83333 7.51889 1.83333 7.13399 2.5L1.93783 11.5C1.55293 12.1667 2.03406 13 2.80386 13H13.1962C13.966 13 14.4471 12.1667 14.0622 11.5L8.86604 2.5ZM8.58647 10.0376L8.71112 5.45453H7.28889L7.41673 10.0376H8.58647ZM7.45828 11.8594C7.60955 12.0085 7.79066 12.0831 8.0016 12.0831C8.13796 12.0831 8.26367 12.049 8.37873 11.9808C8.49379 11.9105 8.58647 11.8178 8.65679 11.7028C8.72923 11.5856 8.76651 11.4567 8.76865 11.316C8.76651 11.1072 8.68874 10.9283 8.53533 10.7791C8.38193 10.63 8.20401 10.5554 8.0016 10.5554C7.79066 10.5554 7.60955 10.63 7.45828 10.7791C7.307 10.9283 7.23242 11.1072 7.23455 11.316C7.23242 11.527 7.307 11.7081 7.45828 11.8594Z" fill=#000000/>
    </svg>
{/if}

{#if icon === 'anchor' }
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path class="{strokeClass}" d="M2.5 11C2.5 11 3 14.5 8 14.5C13 14.5 13.5 11 13.5 11" stroke=#000000 stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
        <path class="{strokeClass}" d="M2.5 12.5V11L4 11.5" stroke=#000000 stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
        <path class="{strokeClass}" d="M13.5 12.5V11L12 11.5" stroke=#000000 stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
        <path class="{strokeClass}" d="M8 14L8 6" stroke=#000000 stroke-width="1" stroke-linecap="round"/>
        <path class="{strokeClass}" d="M11 8H5" stroke=#000000 stroke-width="1" stroke-linecap="round"/>
        <circle class="{strokeClass}" cx="8" cy="4" r="2" stroke=#000000 stroke-width="1" stroke-linecap="round"/>
    </svg>
{/if}

{#if icon === 'x' }
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path class="{strokeClass}" d="M2.5 13.5L8 8M8 8L13.5 13.5M8 8L13.5 2.5M8 8L2.5 2.5" stroke=#000000 stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
{/if}

{#if icon === 'sun' }
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path class="{strokeClass}" d="M8 2L8 1" stroke=#000000 stroke-width="1" stroke-linecap="round"/>
        <path class="{strokeClass}" d="M8 15L8 14" stroke=#000000 stroke-width="1" stroke-linecap="round"/>
        <path class="{strokeClass}" d="M14 8L15 8" stroke=#000000 stroke-width="1" stroke-linecap="round"/>
        <path class="{strokeClass}" d="M1 8L2 8" stroke=#000000 stroke-width="1" stroke-linecap="round"/>
        <path class="{strokeClass}" d="M12.2426 12.2427L12.9497 12.9498" stroke=#000000 stroke-width="1" stroke-linecap="round"/>
        <path class="{strokeClass}" d="M3.05022 3.05028L3.75732 3.75739" stroke=#000000 stroke-width="1" stroke-linecap="round"/>
        <path class="{strokeClass}" d="M3.75728 12.2427L3.05017 12.9498" stroke=#000000 stroke-width="1" stroke-linecap="round"/>
        <path class="{strokeClass}" d="M12.9497 3.05034L12.2426 3.75745" stroke=#000000 stroke-width="1" stroke-linecap="round"/>
        <circle class="{strokeClass}" cx="8" cy="8" r="3" stroke=#000000 stroke-width="1" stroke-linecap="round"/>
    </svg>
{/if}

{#if icon === 'swatches' }
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect class="{strokeClass}" x="2.5" y="2.5" width="4" height="4" stroke=#000000 stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
        <rect class="{strokeClass}" x="2.5" y="9.5" width="4" height="4" stroke=#000000 stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
        <rect class="{strokeClass}" x="9.5" y="2.5" width="4" height="4" stroke=#000000 stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
        <rect class="{strokeClass}" x="9.5" y="9.5" width="4" height="4" stroke=#000000 stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
{/if}

{#if icon === 'code' }
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path class="{strokeClass}" d="M4 5L1 8L4 11" stroke=#000000 stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
        <path class="{strokeClass}" d="M12 5L15 8L12 11" stroke=#000000 stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
        <path class="{strokeClass}" d="M10 3L6 13" stroke=#000000 stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>    
{/if}

{#if icon === 'plus' }
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path class="{strokeClass}" d="M2 7.99996H8.00002M8.00002 7.99996V14M8.00002 7.99996H14M8.00002 7.99996V1.99994" stroke=#000000 stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
{/if}

{#if icon === 'menu' }
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect class="{fillClass}" x="0" y="3" width="16" height="1" rx="1" fill=#000000/>
        <rect class="{fillClass}" x="0" y="7" width="16" height="1" rx="1" fill=#000000/>
        <rect class="{fillClass}" x="0" y="11" width="16" height="1" rx="1" fill=#000000/>
    </svg>
{/if}

{#if icon === 'human' }
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path class="{strokeClass}" d="M2 8H5V15H7V11H9V15H11V8H14V6H2V8Z" stroke="#000000" stroke-linejoin="round"/>
        <circle class="{strokeClass}" cx="8" cy="3" r="2" stroke="#000000" stroke-linejoin="round"/>
    </svg>
{/if}

{#if icon === 'info' }
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle class="{strokeClass}" cx="8" cy="8" r="5.5" stroke="black" stroke-linecap="round"/>
        <path class="{strokeClass}" d="M8 11V7.5" stroke="black" stroke-linecap="round"/>
        <path class="{strokeClass}" d="M8 5V5.5" stroke="black" stroke-linecap="round"/>
    </svg>
{/if}  

{#if icon === 'rainbow' }
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path class="{strokeClass}" d="M15 11C15 7.13401 11.866 4 8 4C4.13401 4 1 7.13401 1 11" stroke="black" stroke-linecap="round"/>
        <path class="{strokeClass}" d="M13 11C13 8.23858 10.7614 6 8 6C5.23858 6 3 8.23858 3 11" stroke="black" stroke-linecap="round"/>
        <path class="{strokeClass}" d="M11 11C11 9.34315 9.65685 8 8 8C6.34315 8 5 9.34315 5 11" stroke="black" stroke-linecap="round"/>
    </svg>
{/if}

{#if icon === 'copy' }
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path class="{strokeClass}" d="M11 4V4C11 2.89543 10.1046 2 9 2H5C3.89543 2 3 2.89543 3 4V10C3 11.1046 3.89543 12 5 12V12" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
        <path class="{strokeClass}" d="M6.5 12L9 12C10.1046 12 11 11.1046 11 10L11 5.5" stroke="black" stroke-linejoin="round" stroke-dasharray="1 2"/>
        <rect class="{strokeClass}" x="6.5" y="5.5" width="7" height="9" rx="1.5" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
{/if}



<style>
    .stroke-text {
        stroke: var(--text);
    }
    .stroke-disabled {
        stroke: var(--text-disabled);
    }
    .stroke-alert {
        stroke: var(--alert);
    }
    .stroke-black {
        stroke: black;
    }
    .stroke-white {
        stroke: white;
    }

    .fill-text {
        fill: var(--text);
    }
    .fill-disabled {
        fill: var(--text-disabled);
    }
    .fill-alert {
        fill: var(--alert);
    }
    .fill-black {
        fill: black;
    }
    .fill-white {
        fill: white;
    }
</style>